import React from "react";

import { AlertContextProvider } from "./AlertContext";

import TawkTo from "../components/tawkTo/TawkTo";

const AppContext = ({ children }: React.PropsWithChildren) => {
  return (
    <AlertContextProvider>
      <TawkTo />
      {children}
    </AlertContextProvider>
  );
};

export default AppContext;
